import { join } from "path";
import { firebaseCloudFunctionHost, firebaseFunctionHost } from "config/fetch";
import { InternalServerError } from "lib/error";

export async function fetchWithToken<ResponseInterface = any>(
  url: string,
  token: string,
  init?: RequestInit
): Promise<ResponseInterface> {
  const headers = init?.headers || {};
  headers["Authorization"] = `Bearer: ${token}`;
  const requestInit = Object.assign({}, init, { headers });
  try {
    const res = await fetch(url, requestInit);
    return await res.json();
  } catch (err) {
    console.error(err);
  }
}

export async function requestCloudFunction(
  url: string,
  token: string,
  requestBody: string | object
) {
  const body =
    typeof requestBody === "object" ? JSON.stringify(requestBody) : requestBody;
  const requestInit = {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer: ${token}`,
    },
    body,
  };
  const endpoint = join(firebaseCloudFunctionHost, url);
  try {
    return await fetch(`${location.protocol}//${endpoint}`, requestInit);
  } catch (error) {
    if (error == "TypeError: Failed to fetch") {
      throw new InternalServerError();
    } else {
      throw error;
    }
  }
}

export async function sendRequest(
  token: string,
  path: string,
  requestBody?: string | object
) {
  const body =
    typeof requestBody === "object" ? JSON.stringify(requestBody) : requestBody;
  const requestInit = {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer: ${token}`,
    },
    body,
  };
  try {
    return await fetch(`${firebaseFunctionHost}${path}`, requestInit);
  } catch (error) {
    if (error == "TypeError: Failed to fetch") {
      throw new InternalServerError();
    } else {
      throw error;
    }
  }
}

export async function sendNoTokenRequest(
  path: string,
  requestBody?: string | object
) {
  const body =
    typeof requestBody === "object" ? JSON.stringify(requestBody) : requestBody;
  const requestInit: RequestInit = {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body,
  };
  try {
    return await fetch(`${firebaseFunctionHost}${path}`, requestInit);
  } catch (error) {
    if (error == "TypeError: Failed to fetch") {
      throw new InternalServerError();
    } else {
      throw error;
    }
  }
}
